<template lang="pug">
  .w-full.bottom-0.left-0(:class="[position, {'blend-diff': isFilterEffect}]", v-if="announcements")
    //- items...
    template(v-for="item in announcements")
      template(v-if="!expired(item.expiry_date)")
        //- (filter effect)
        template(v-if="item.style === 'filter effect'")
          wp-link.block.text-center.text-15.uppercase.leading-tighter.tracking-20.py-16.px-24(, :link="item.link_to")
            span.inline-block.bg-white.text-black(v-html="item.message || '&nbsp;'", :style="{backgroundColor: item.bg_color, color: item.text_color}")
        //- solid color
        template(v-else)
          wp-link.bg-black.text-white.text-center.font-sans-demicd-off.uppercase.text-13.leading-tighter.tracking-20(v-if="!expired(item.expiry_date)", :link="item.link_to")
            span.block.py-10.px-24(v-html="item.message || '&nbsp;'", :style="{backgroundColor: item.bg_color, color: item.text_color}")
</template>

<script>
import { mapState } from 'vuex'
import wpLink from '@/components/WPLink'
export default {
  name: 'Announcements',
  computed: {
    ...mapState(['site']),
    announcements () {
      return (this.site && this.site.announcements) || []
    },
    position () {
      const isFxd = this.$route.name && this.$route.name.includes('product')
      return isFxd ? 'fixed' : 'sticky'
    },
    isFilterEffect () {
      return this.announcements.find(itm => itm.style === 'filter effect')
    }
  },
  methods: {
    expired (date) {
      if (!date) return false
      return new Date() >= new Date(date)
    }
  },
  components: { wpLink }
}
</script>

<style>
</style>
